<app-header></app-header>

<div class="banner-wrapper">
  <button class="back-arrow" [attr.aria-label]="'common.goBack' | translate" (click)="goToHome()">
    <span class="material-icons">arrow_back</span>
  </button>

  <div class="filters">
  <!-- COUNTRY FILTER -->

  <mat-icon>filter_list</mat-icon>

  <div class="mat-fields">

  <mat-form-field appearance="outline" floatLabel="always">

    <mat-label>{{ 'all-companies.country.select.title' | translate }}</mat-label>
    <mat-select placeholder="{{ 'all-companies.country.placeholder' | translate}}" [(ngModel)]="selectedCountryId" (selectionChange)="onCountryChange()">

      <mat-option [value]="null">{{ 'all-companies.country.select.default' | translate }}</mat-option>
      @for(country of countries;track country.id) {
      <mat-option [value]="country.id">{{ country.name }}</mat-option>
      } 

    </mat-select>

  </mat-form-field>

  <!-- CITY FILTER -->
  <mat-form-field appearance="outline" floatLabel="always" [class.disabled]="selectedCountryId == null">

    <mat-label>{{ 'all-companies.city.select.title' | translate }}</mat-label>
    <mat-select placeholder="{{ 'all-companies.city.placeholder' | translate }}" [(ngModel)]="selectedCities" (selectionChange)="onCitiesChange()" [disabled]="selectedCountryId == null" multiple>
      <mat-select-trigger>
        @if (selectedCities.includes(0)) {
          {{ 'common.allCities' | translate }}
        } @else {
          {{ getSelectedCityName(selectedCities[0]) }}
          @if ((selectedCities.length || 0) > 1) {
            <span class="additional-selection">
              (+{{(selectedCities.length || 0) - 1}} {{ selectedCities.length === 2 ? ('common.other' | translate) : ('common.others' | translate) }})
            </span>
          }
        }
      </mat-select-trigger>
      <mat-option [value]="0">{{ 'all-companies.city.select.default' | translate }}</mat-option>
      @for(city of filteredCities;track city.id) {
      <mat-option [value]="city.id">
        {{ city.name }}
      </mat-option>
      } 

    </mat-select>

  </mat-form-field>

  <!-- SECTOR FILTER -->
  <mat-form-field appearance="outline" floatLabel="always">

    <mat-label>{{ 'all-companies.sector.select.title' | translate }}</mat-label>
    <mat-select placeholder="{{ 'all-companies.sector.select.title' | translate }}" [(ngModel)]="selectedSectorId" (selectionChange)="applyFilters()">

      <mat-option [value]="null">{{ 'all-companies.sector.select.default' | translate }}</mat-option>
      @for(sector of sectors;track sector.id) {
      <mat-option [value]="sector.id">{{ sector.name }}</mat-option>
      } 

    </mat-select>

  </mat-form-field>

  <!-- BADGE FILTER -->
  <div class="badge-toggle" [class.active]="badgeFilter" (click)="badgeCheckFilter()">
    <mat-icon>workspace_premium</mat-icon>
    <span>{{ 'common.badge' | translate }}</span>
  </div>

  </div>

</div>


  <div class="filterss">
    <input
      type="text"
      name="company"
      class="country-input"
      placeholder="{{ 'all-companies.search' | translate }}"
      [(ngModel)]="searchTerm"
      (input)="onSearchChange()"
    />
    <mat-icon>search</mat-icon>
  </div>
</div>

<section class="content-wrapper">
  <aside class="filters-sidebar">
    <h2>{{ 'common.filters' | translate }}</h2>

    <div
      class="accordion"
      *ngFor="let filter of filters; let i = index"
      [class.active]="filter.open"
    >
      <button class="accordion-header" (click)="toggleAccordion(i)">
        {{ filter.title | translate}}
        <span class="arrow">▸</span>
      </button>

      <div class="accordion-content">
        <ng-container *ngIf="filter.name === 'dimension'">
          <div *ngFor="let dim of filter.dimensions" class="dimension-filter">
            <label>{{ dim.label }}</label>
            <div class="stars">
              <span
                *ngFor="let star of [1,2,3,4,5]"
                (click)="setDimensionRating(dim, star)"
                (mouseenter)="dim.hoverRating = star"
                (mouseleave)="dim.hoverRating = 0"
                [class.filled]="star <= (dim.hoverRating || dim.rating)"
                class="star"
              >&#9733;</span>
            </div>
          </div>
          <button class="reset-btn" (click)="resetDimensionFilters()">{{ 'common.resetStars' | translate }}</button>
        </ng-container>

        <ng-container *ngIf="filter.name === 'inclusionIndex'">
          <div class="range-filter">
            <label for="inclusionIndexSlider">{{ 'common.selectInclusionIndex' | translate }}: {{ filter.value }}</label>
            <input
              type="range"
              id="inclusionIndexSlider"
              name="inclusionIndex"
              min="{{ filter.min }}"
              max="{{ filter.max }}"
              [(ngModel)]="filter.value"
              (change)="applyFilters()"
            />
            <div class="range-labels">
              <span *ngFor="let i of [1,2,3,4,5]">{{ i }}</span>
            </div>
            <button class="reset-btn" (click)="resetInclusionIndexFilter()">{{ 'common.resetInclusionIndex' | translate }}</button>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="color-legend-box">
      <strong>{{ 'common.scoreLegend' | translate }}:</strong>
      <div class="color-legend">
        <div><span class="color-dot red"></span> {{ 'common.poor' | translate }}</div>
        <div><span class="color-dot yellow"></span> {{ 'common.fair' | translate }}</div>
        <div><span class="color-dot blue"></span> {{ 'common.good' | translate }}</div>
        <div><span class="color-dot green"></span> {{ 'common.excellent' | translate }}</div>
      </div>
    </div>
  </aside>

  <div class="companies-content">
    <div class="companies-container">
      <div
        class="company-card"
        *ngFor="let company of filteredCompanies"
        (click)="openCompanyModal(company)"
      >
      <div class="card-top">
        <div class="logo-container" *ngIf="company.logoBase64">
          <img
            [src]="'data:image/png;base64,' + company.logoBase64"
            alt="{{ company.name }} logo"
            class="company-logo"
          />
        </div>
        <div class="card-info">
          @if (company.badge) {
            <h3>{{ company.name }} <mat-icon class="icon-badge">workspace_premium</mat-icon></h3>
          }
          @else {
            <h3>{{ company.name }}</h3>
          }
          <p>{{ company.country?.name || company.city?.country?.name || 'N/A' }}, {{ company.city?.name || 'N/A' }}</p>
          <div class="rating">
            ⭐ <span>{{ company.inclusionIndex != null ? company.inclusionIndex.toFixed(2) : 'N/A' }}</span>
          </div>
        </div>
      </div>

      <div class="card-bottom">
        <div class="trainee-count">
          👨‍🎓 {{ 'home.companycard.trainees' | translate }} <strong>{{ company.traineesCompletedCount }}</strong>
        </div>

        <button
          class="accordion-header"
          (click)="toggleCompanyExpansion(company.id); $event.stopPropagation()"
        >
          {{ 'common.inclusionIndex' | translate }}
          <span class="arrow" [class.expanded]="expandedCompanyId === company.id">▸</span>
        </button>

        <div
          class="accordion-content"
          [style.maxHeight]="expandedCompanyId === company.id ? '300px' : '0'"
          [style.paddingTop]="expandedCompanyId === company.id ? '0.5rem' : '0'"
          [style.paddingBottom]="expandedCompanyId === company.id ? '0.5rem' : '0'"
          [style.overflow]="expandedCompanyId === company.id ? 'visible' : 'hidden'"
          [style.transition]="'max-height 0.3s ease-out, padding 0.3s ease-out'"
        >
         <ng-container *ngIf="expandedCompanyId === company.id">
    <div *ngFor="let dim of dimensionLabels" class="dimension-row">
      <label>
        <span
          class="color-dot"
          [ngStyle]="{'background-color': getColor(company.dimensionScores?.[dim.key])}">
        </span>
        {{ dim.label | translate}}
      </label>
      <div class="rating-value">
        {{ getDimensionScore(company, dim.key) }}
      </div>
    </div>
  </ng-container>
        </div>
      </div>
      </div>
    </div>

    <div class="pagination" *ngIf="totalPages > 0">
      <div class="viewPage">
        <span class="pagination-count">
          {{ 'all-companies.pagination.showing' | translate }}
          <strong>{{ firstDisplayedElement }}</strong>
          &ndash;
          <strong>{{ lastDisplayedElement }}</strong>
          {{ 'all-companies.pagination.of' | translate }}
          <strong>{{ totalElements }}</strong>
          {{ 'all-companies.pagination.companies' | translate }}
        </span>
      </div>

      <div class="pageChange">
        <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">◀</button>
        <button
          *ngFor="let page of [].constructor(totalPages); let i = index"
          (click)="changePage(i + 1)"
          [class.active]="currentPage === i + 1"
        >
          {{ i + 1 }}
        </button>
        <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">▶</button>
      </div>
    </div>
  </div>
</section>


<!-- <div class="logo-container">
  <h2>Logo aziendale</h2>

  <input type="file" (change)="onFileSelected($event)" />
  <button (click)="uploadLogo()">Carica</button>
  <button (click)="fetchLogo()">Carica dal server</button>

  <div *ngIf="error" style="color:red">{{ error }}</div>

  <div *ngIf="logoBase64" class="preview">
    <h3>Anteprima:</h3>
    <img [src]="'data:image/png;base64,' + logoBase64" alt="Company Logo" width="200" />
  </div>
</div>
 -->
<app-footer></app-footer>
